<template>
  <section class="documents">
    <div class="container">
      <div class="header">
        <button @click="pageRefresh">Atualizar Lista</button>
        <input
          type="text"
          placeholder="Buscar Nº do Pedido"
          id="inputSearch"
          @keyup="searchOrder"
        />
      </div>
      <div class="loader" v-if="loader">
        <i class="fas fa-circle-notch fa-spin"></i>
      </div>
      <div class="table" style="overflow-x: auto">
        <table v-if="!loader" id="table">
          <thead>
            <tr>
              <th>Liberar</th>
              <th>Pedido</th>
              <th>Bloqueio</th>
              <th>Data</th>
              <th>Total</th>
              <th>Descontos</th>
              <th>Vendedor</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(bloq, index) in infos" :key="index">
              <td width="15%">
                <button @click="liberarPedido(bloq)" class="liberar">
                  Liberar Pedido
                </button>
              </td>
              <td>
                <router-link
                  :to="'/panel/orders/DetailsOrder?Pedido=' + bloq.nrpedido"
                >
                  {{ bloq.nrpedido }}
                </router-link>
              </td>
              <td>
                {{ bloq.dsbloqueio }}
              </td>
              <td>
                {{ moment(bloq.dt_inclusao).format("DD/MM/YYYY HH:mm:ss") }}
              </td>
              <td>
                {{ bloq.Liquido | toCurrency }}
              </td>
              <td>
                {{ bloq.YDES | toCurrency }} [{{ bloq.condicao_bloqueada }}%]
              </td>
              <td>
                {{ bloq.Vendedor }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      infos: [],
      loader: false,
      token: null,
      nomeUsuario: null,
    };
  },
  methods: {
    async getDados() {
      let dados = JSON.parse(localStorage.getItem("login"));

      this.token = dados.token;
      this.nomeUsuario = dados.nomeUsuario;
      this.loader = true;

      const response = await axios({
        method: "get",
        url: `https://www.leverosintegra.com.br/Map/Api/PedidosBloqueados?token=${this.token}`,
      });

      this.infos = response.data;
      this.loader = false;
    },

    searchOrder() {
      let input, filter, table, tr, td, i, txtValue;
      input = document.getElementById("inputSearch");
      filter = input.value;
      table = document.getElementById("table");
      tr = table.getElementsByTagName("tr");
      for (i = 0; i < tr.length; i++) {
        td = tr[i].getElementsByTagName("td")[1];

        if (td) {
          txtValue = td.textContent || td.innerText;
          if (txtValue.indexOf(filter) > -1) {
            tr[i].style.display = "";
          } else {
            tr[i].style.display = "none";
          }
        }
      }
    },

    pageRefresh() {
      window.location.reload();
    },

    async liberarPedido(bloq) {
      let tipo = bloq.DS_TIPO;
      let usuario = this.nomeUsuario;
      let nrPedido = bloq.nrpedido;
      let idBloqueio = bloq.id_bloqueio;
      const response2 = await axios({
        method: "post",
        url: `https://www.leverosintegra.com.br/Map/Api/Orders?Tipo=${tipo}&Usuario=${usuario}&NrPedido=${nrPedido}&IdBloqueio=${idBloqueio}&token=${this.token}`,
        //url: `http://qa.leverosintegra.com.br/map/Api/Orders?Tipo=${tipo}&Usuario=${usuario}&NrPedido=${nrPedido}&IdBloqueio=${idBloqueio}&token=${this.token}`,
        //url: `http://localhost:54015/Api/Orders?Tipo=${tipo}&Usuario=${usuario}&NrPedido=${nrPedido}&IdBloqueio=${idBloqueio}&token=${this.token}`
      });
      if (response2.status == 200) {
        window.location.reload();
      }
    },
  },

  beforeMount() {
    this.getDados();
  },
};
</script>

<style lang="scss" scoped>
.documents {
  .container {
    max-width: 90%;
    margin: 0 auto;

    .header {
      display: flex;
      margin: 20px 0;

      button {
        background: var(--standardGreen);
        color: var(--customWhite);
        border-radius: 5px;
        padding: 10px;
        width: 40%;
      }

      input {
        border-bottom: 1px solid var(--customGray-500);
        outline: none;
        margin-left: 20px;
        color: var(--customGray-500);
        width: 100%;
      }
    }

    .loader {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 80px;

      i {
        color: var(--customBlue);
        font-size: 4rem;
      }
    }

    .table {
      table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        thead {
          tr {
            th {
              background: var(--customGray-70);
              padding: 5px;
            }
          }
        }

        tbody {
          tr {
            td {
              padding: 10px;
              border-bottom: 1px solid var(--customGray-100);
              text-align: center;

              button {
                background: var(--customGray-100);
                color: var(--customGray-800);
                border-radius: 10px;
                padding: 5px;
                outline: none;
              }

              a {
                color: var(--customDarkGreen);
              }
            }
          }
        }
      }
    }
  }
}
</style>